'use strict';

const FetchHandler = require('../../deal/frontend/FetchHandler');

const PurchaseCreditsMessage = {
  init(payload, done) {
    const $purchaseCreditsPlaceholders = document.querySelectorAll(
      '.purchase-credits-messaging.placeholder'
    );
    if (!$purchaseCreditsPlaceholders.length) {
      return done();
    }

    const $purchaseCreditsFetchHandler = new FetchHandler({
      url: '/deals/user_proxy/available_credits',
      requestOpts: { credentials: 'same-origin' },
    });

    $purchaseCreditsFetchHandler.send().then(res => {
      if (res && res.amount && res.unit) {
        const amount = `<span class='c-txt-price' data-bhc='numBucks:${res.amount}'>$${res.amount}</span>`;
        const unit = res.unit;

        const purchaseCreditsMessage = window.I18n.t(
          'js.modules.buy_button.new_purchase_credits_messaging',
          { amount, unit }
        );
        $purchaseCreditsPlaceholders.forEach($placeholder => {
          $placeholder.dataset.bhw = 'BucksDealPageDisplay';
          $placeholder.innerHTML = `<span class='icon-bucks c-txt-price'></span><div>${purchaseCreditsMessage}</div>`;
          $placeholder.classList.remove('placeholder');
        });
      } else {
        $purchaseCreditsPlaceholders.forEach($placeholder =>
          $placeholder.parentNode.removeChild($placeholder)
        );
      }
    });

    return done();
  },
};

module.exports = PurchaseCreditsMessage;
